import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Upload } from 'antd';
/**personal Component**/

import { getQiniuTokenAPI, QINIU_DOMAIN } from '@/API';

import { getQiniuOption } from '@/constData';
import { typeMap } from '../../constData';

// 参数

const nameMap = {
	mis_smaller_image: '小图',
	mis_middle_image: '中图',
	mis_bigger_image: '大图',
	mis_order_image: '排序图'
}
class ImgGroup extends Component {
	state = {
		uptoken: ''
	}
	componentDidMount() {

		getQiniuTokenAPI().then((res) => {
			let uptoken = res.data.uptoken;
			this.setState({uptoken})
		});
	}

	uploadSuccess = (res, index) => {
		const domain = 'https://tikuqiniu.knowbox.cn/';
		let { newImgList, editParam } = this.props;
		let newArr = [...newImgList];
		newArr[index] = `${QINIU_DOMAIN}${res.key}`;
		editParam && editParam({newImgList: newArr});
	}

	render () {
		const { imgData, type, newImgList } = this.props;
		const { uptoken } = this.state;
		const uploadProps = {
			data:{
				token: uptoken
			},
		    action: "//up.qbox.me/",
		    showUploadList: false
		}
		return (
			<ul className="img-group">
				{
					imgData && imgData.length > 0 && imgData.map((item, i) => 
						<li key={i}>
							<div className="clearfix">
								<div className="img-split">
									<p>{`图片类型：${nameMap[item.name]}`}</p>
									<div className="img-content">
										<img src={item.src} title="原图" />
									</div>
								</div>
								<div className="img-split">
									<p></p>
									<div className="img-content">
										<img id={`preview_img_${i}`} src={newImgList[i] ? newImgList[i] : `static/img/default_img.png`} alt="新图" />
									</div>
								</div>
							</div>
							{
								(type !== typeMap.finish) && 
									<Upload 
						            	{...uploadProps}
						            	accept="image/*"
						            	className="upload-class clearfix"
						            	onSuccess={(res)=>this.uploadSuccess(res, i)}
						            >
						                <div className="upload-img clearfix">
											<Button>上传图片</Button>
										</div>
						            </Upload>
									
							}
							
						</li>
					)		
				}
				
			</ul>
		)
	}
}

const mapStateToProps = state => {
	return {}
}

const mapDispatchToProps = dispatch => {
	return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ImgGroup)



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/image_correction/image_correction_detail/common/imgGroup.js